import {
  ExpandedDetailsSection,
  Flex,
  FlexColumn,
  AnomalyChart,
  AutoFreshnessChart,
  TestLineageNavButton,
} from '@elementary/common-ui/components';
import { CondensedTable } from '@elementary/common-ui/components/Table';
import {
  TestConfiguration,
  TestResult,
  Report,
} from '@elementary/common-ui/types';
import AdditionalActionsButton from './AdditionalActionsButton';
import OpenTestRunsButton from './OpenTestRunsButton';

const AnomalyDetectionExpandedRow = ({
  rowData,
  showWidgetButtons,
  loading = false,
}: {
  rowData: TestResult;
  reportData: Report;
  showWidgetButtons: boolean;
  loading?: boolean;
}) => {
  const { test_results: testResults, metadata } = rowData || {};

  return (
    <FlexColumn sx={{ gap: 2 }}>
      <Flex sx={{ justifyContent: 'space-between' }}>
        {showWidgetButtons && (
          <Flex gap={1} sx={{ alignSelf: 'flex-end', marginLeft: 'auto' }}>
            <OpenTestRunsButton urlParam={metadata.elementary_unique_id} />
            {!!metadata.model_unique_id && (
              <TestLineageNavButton
                modelId={metadata.model_unique_id}
                testName={metadata.test_name}
              />
            )}
            <AdditionalActionsButton
              elementaryUniqueId={rowData.metadata.elementary_unique_id}
            />
          </Flex>
        )}
      </Flex>
      {!Array.isArray(testResults?.metrics) ? ( // dimensioned test
        <CondensedTable
          data={testResults?.metrics?.test_rows_sample || []}
          columns={testResults?.metrics?.headers || []}
        />
      ) : rowData.metadata.test_name === 'freshness_anomalies' &&
        rowData.metadata.test_sub_type === 'automated' ? (
        <AutoFreshnessChart
          metrics={
            Array.isArray(testResults?.metrics)
              ? testResults?.metrics
              : [testResults?.metrics || {}]
          }
          status={rowData.metadata.latest_run_status}
          loading={loading}
        />
      ) : (
        <AnomalyChart
          metrics={
            Array.isArray(testResults?.metrics)
              ? testResults?.metrics
              : [testResults?.metrics || {}]
          }
          status={rowData.metadata.latest_run_status}
          metricsTitle={rowData?.test_results?.display_name}
          failOnZero={metadata?.test_params?.fail_on_zero}
          anomalyDirection={
            (metadata?.configuration as TestConfiguration)?.anomaly_direction
          }
          detectionPeriod={
            metadata.test_params.backfill_days
              ? { count: metadata.test_params.backfill_days, period: 'day' }
              : metadata.test_params.detection_period
          }
          detectionDelay={metadata.test_params.detection_delay}
          loading={loading}
        />
      )}

      <ExpandedDetailsSection data={rowData} />
    </FlexColumn>
  );
};

export default AnomalyDetectionExpandedRow;
